module.exports = __webpack_public_path__ + "static/img/web.05c8b129.svg";